import React from "react";
import {
  FiServer,
  FiHash,
  FiShoppingCart,
  FiUsers,
  FiPlus,
  FiHome,
  FiEdit,
  FiUser,
  FiPackage,
  FiAlertCircle,
  FiZap,
  FiClock,
  FiList,
  FiStopCircle,
  FiBarChart2,
  FiTrendingUp,
  FiCheckSquare,
  FiLayers,
  FiShield,
  FiCreditCard,
  FiBriefcase,
} from "react-icons/fi";
import { translate } from "./hooks/translate";
import { FiFileText } from "react-icons/fi";
import AssemblyProducts from "./views/pages/AssemblyProducts";
import PackagingProducts from "./views/pages/PackagingProducts";
import PrivacyPolicy from "./views/pages/PrivacyPolicy";
const Dashboard = React.lazy(() => import("./views/pages/Dashboard"));
const Ecommerce = React.lazy(() => import("./views/pages/Ecommerce"));
const Profile = React.lazy(() => import("./views/pages/Profile"));
const BankAccounts = React.lazy(() => import("./views/pages/BankAccounts"));
const CompanySettings = React.lazy(
  () => import("./views/pages/CompanySettings"),
);
const DeviceModels = React.lazy(() => import("./views/pages/DeviceModels"));
const SerialNumbers = React.lazy(() => import("./views/pages/SerialNumbers"));
const DeviceSales = React.lazy(() => import("./views/pages/DeviceSales"));
const CreateDeviceSale = React.lazy(
  () => import("./views/pages/DeviceSales/CreateDeviceSale"),
);
const EditDeviceSale = React.lazy(
  () => import("./views/pages/DeviceSales/EditDeviceSale"),
);
const Users = React.lazy(() => import("./views/pages/Users"));
const CreateDeviceModel = React.lazy(
  () => import("./views/pages/DeviceModels/CreateDeviceModel"),
);
const Products = React.lazy(() => import("./views/pages/Products"));
const AssemblyDevices = React.lazy(
  () => import("./views/pages/AssemblyProducts"),
);
const PackagingDevices = React.lazy(
  () => import("./views/pages/PackagingProducts"),
);
const Companies = React.lazy(() => import("./views/pages/Companies"));
const Licenses = React.lazy(() => import("./views/pages/Licenses"));
const CreateCompany = React.lazy(
  () => import("./views/pages/Companies/CreateCompany"),
);
const CompanyDetails = React.lazy(
  () => import("./views/pages/Companies/CompanyDetails"),
);
const Dealers = React.lazy(() => import("./views/pages/Dealers"));
const CreateDealer = React.lazy(
  () => import("./views/pages/Dealers/CreateDealer"),
);
const Page404 = React.lazy(() => import("./views/pages/Page404"));
const ProducedDevices = React.lazy(
  () => import("./views/pages/ProducedDevices"),
);
const Activities = React.lazy(() => import("./views/pages/Activities"));
const ActivityDetails = React.lazy(
  () => import("./views/pages/Activities/ActivityDetails"),
);
const Devices = React.lazy(() => import("./views/pages/Devices"));
const Machines = React.lazy(() => import("./views/pages/Machines"));
const MachineAssignments = React.lazy(
  () => import("./views/pages/MachineAssignments"),
);
const Inventory = React.lazy(() => import("./views/pages/Inventory"));
const InventoryTree = React.lazy(
  () => import("./views/pages/Inventory/InventoryTree"),
);
const AddInventory = React.lazy(
  () => import("./views/pages/Inventory/AddInventory"),
);
const InventoryAdditions = React.lazy(
  () => import("./views/pages/Inventory/InventoryAdditions"),
);
const ProductionLines = React.lazy(
  () => import("./views/pages/ProductionLines"),
);
const ProductionLineFormPage = React.lazy(
  () => import("./views/pages/ProductionLines/ProductionLineFormPage"),
);
const ViewProductionLines = React.lazy(
  () => import("./views/pages/ProductionLines/ViewProductionLines"),
);
const SubProductionLines = React.lazy(
  () => import("./views/pages/ProductionLines/SubProductionLines"),
);
const ViewSubProductionLines = React.lazy(
  () => import("./views/pages/ProductionLines/ViewSubProductionLines"),
);
const ProductionEntry = React.lazy(
  () => import("./views/pages/ProductionLines/ProductionEntry"),
);
const CreateMachineAssignment = React.lazy(
  () => import("./views/pages/MachineAssignments/CreateMachineAssignment"),
);
const EditMachineAssignment = React.lazy(
  () => import("./views/pages/MachineAssignments/EditMachineAssignment"),
);
const Deliveries = React.lazy(() => import("./views/pages/Deliveries"));
const CreateDelivery = React.lazy(
  () => import("./views/pages/Deliveries/CreateDelivery"),
);
const ViewDelivery = React.lazy(
  () => import("./views/pages/Deliveries/ViewDelivery"),
);
const DeviceMonitor = React.lazy(() => import("./views/pages/DeviceMonitor"));
const StockProducts = React.lazy(() => import("./views/pages/StockProducts"));
const DefectiveProducts = React.lazy(
  () => import("./views/pages/DefectiveProducts"),
);
const Logs = React.lazy(() => import("./views/pages/Logs"));
const UserProfiles = React.lazy(() => import("./views/pages/UserProfiles"));
const ProfileForm = React.lazy(
  () => import("./views/pages/UserProfiles/ProfileForm"),
);
const SystemCompanies = React.lazy(
  () => import("./views/pages/SystemCompanies"),
);
const Shifts = React.lazy(() => import("./views/pages/Shifts"));
const ShiftForm = React.lazy(() => import("./views/pages/Shifts/ShiftForm"));
const StopReasons = React.lazy(() => import("./views/pages/StopReasons"));
const ProductionLogs = React.lazy(() => import("./views/pages/ProductionLogs"));
const Orders = React.lazy(() => import("./views/pages/Orders"));
const PermissionApproves = React.lazy(
  () => import("./views/pages/PermissionApproves"),
);
const CreateOrder = React.lazy(
  () => import("./views/pages/Orders/CreateOrder"),
);
const EditOrder = React.lazy(() => import("./views/pages/Orders/CreateOrder"));
const OEEClasses = React.lazy(() => import("./views/pages/OEEClasses"));
const OEEGroups = React.lazy(() => import("./views/pages/OEEGroups"));
const MachineStopLogs = React.lazy(
  () => import("./views/pages/MachineStopLogs"),
);
const TEEP = React.lazy(() => import("./views/pages/TEEP"));
const MachineMonitor = React.lazy(() => import("./views/pages/MachineMonitor"));
const MachineReport = React.lazy(() => import("./views/pages/MachineReport"));
const StoppingGroups = React.lazy(() => import("./views/pages/StoppingGroups"));
const Parts = React.lazy(() => import("./views/pages/Parts"));
const PartUnits = React.lazy(() => import("./views/pages/PartUnits"));
const PartVariants = React.lazy(() => import("./views/pages/PartVariants"));
const PartMachines = React.lazy(() => import("./views/pages/PartMachines"));
const PartAssemblies = React.lazy(() => import("./views/pages/PartAssemblies"));
const PartStockAdditions = React.lazy(
  () => import("./views/pages/Parts/PartStockAdditions"),
);
const ScrapEntry = React.lazy(() => import("./views/pages/ScrapEntry"));
const ScrapGroups = React.lazy(() => import("./views/pages/ScrapGroups"));
const OEEReport = React.lazy(() => import("./views/pages/Reports/OEE"));
const OEEByMachineReport = React.lazy(
  () => import("./views/pages/Reports/OEE/ByMachine"),
);
const ProductionReportRedirect = React.lazy(
  () => import("./views/pages/Reports/Production"),
);
const ProductionByPartPerPart = React.lazy(
  () => import("./views/pages/Reports/Production/ByPart/PerPart"),
);
const ProductionByPartTrend = React.lazy(
  () => import("./views/pages/Reports/Production/ByPart/Trend"),
);
const ProductionByPartMatrix = React.lazy(
  () => import("./views/pages/Reports/Production/ByPart/Matrix"),
);
const ProductionByMachineTrend = React.lazy(
  () => import("./views/pages/Reports/Production/ByMachine/Trend"),
);
const ProductionByMachineDistribution = React.lazy(
  () => import("./views/pages/Reports/Production/ByMachine/Distribution"),
);
const ProductionByMachineTotals = React.lazy(
  () => import("./views/pages/Reports/Production/ByMachine/Totals"),
);
const QualityReportRedirect = React.lazy(
  () => import("./views/pages/Reports/Quality"),
);
const QualityTrendReport = React.lazy(
  () => import("./views/pages/Reports/Quality/Trend"),
);
const QualityByPartReport = React.lazy(
  () => import("./views/pages/Reports/Quality/ByPart"),
);
const DowntimeReportRedirect = React.lazy(
  () => import("./views/pages/Reports/Downtime"),
);
const DowntimeTrendReport = React.lazy(
  () => import("./views/pages/Reports/Downtime/Trend"),
);
const DowntimeReasonsReport = React.lazy(
  () => import("./views/pages/Reports/Downtime/Reasons"),
);
const DowntimeByMachineReport = React.lazy(
  () => import("./views/pages/Reports/Downtime/ByMachine"),
);
const DeviceStatusReport = React.lazy(
  () => import("./views/pages/Reports/DeviceStatus"),
);
const ActivitiesReport = React.lazy(
  () => import("./views/pages/Reports/Activities"),
);
const SalesReportRedirect = React.lazy(
  () => import("./views/pages/Reports/Sales"),
);
const SalesTrendReport = React.lazy(
  () => import("./views/pages/Reports/Sales/Trend"),
);
const SalesByModelReport = React.lazy(
  () => import("./views/pages/Reports/Sales/ByModel"),
);
const SalesRevenueReport = React.lazy(
  () => import("./views/pages/Reports/Sales/Revenue"),
);
const DeliveriesReportRedirect = React.lazy(
  () => import("./views/pages/Reports/Deliveries"),
);
const DeliveriesTrendReport = React.lazy(
  () => import("./views/pages/Reports/Deliveries/Trend"),
);
const DeliveriesByModelReport = React.lazy(
  () => import("./views/pages/Reports/Deliveries/ByModel"),
);
const PartMachineAssignmentForm = React.lazy(
  () => import("./views/pages/PartMachines/AssignmentForm"),
);
const PartMachineAssignmentView = React.lazy(
  () => import("./views/pages/PartMachines/ViewAssignment"),
);
const EPC = React.lazy(() => import("./views/pages/EPC"));
const ProductionPlans = React.lazy(
  () => import("./views/pages/ProductionPlanning/Plans"),
);
const FeasibilityAnalysis = React.lazy(
  () => import("./views/pages/ProductionPlanning/Feasibility"),
);
const ShortageReport = React.lazy(
  () => import("./views/pages/ProductionPlanning/Shortage"),
);
const Notifications = React.lazy(() => import("./views/pages/Notifications"));
const NotificationSettings = React.lazy(
  () => import("./views/pages/NotificationSettings"),
);
const ApprovalWorkflows = React.lazy(
  () => import("./views/pages/ApprovalWorkflows"),
);
const WorkflowForm = React.lazy(
  () => import("./views/pages/ApprovalWorkflows/WorkflowForm"),
);
const ProductionCapacity = React.lazy(
  () => import("./views/pages/ProductionCapacity"),
);
const routes = [
  { path: "/", exact: true, name: "Home" },
  { path: "", exact: true, name: "Dashboard", element: Dashboard },
  { path: "/ecommerce", exact: true, name: "Analytics", element: Ecommerce },
  { path: "/404", exact: true, name: "404", element: Page404 },
  {
    path: "/production-capacity",
    name: "Üretim Kapasitesi",
    icon: <FiBarChart2 />,
    element: ProductionCapacity,
    group: "Raporlar",
  },
  {
    path: "/account/profile",
    name: "Profil",
    icon: <FiUser />,
    element: Profile,
    group: "Profil",
  },
  {
    path: "/account/bank-accounts",
    name: "Banka Hesapları",
    icon: <FiCreditCard />,
    element: BankAccounts,
    group: "Profil",
  },
  {
    path: "/account/company-settings",
    name: "Firma Ayarları",
    icon: <FiBriefcase />,
    element: CompanySettings,
    group: "Profil",
  },
  {
    path: "/products",
    name: "Ürünler",
    icon: <FiServer />,
    element: Products,
    group: "Ürün Yönetimi",
  },
  {
    path: "/assembly-products",
    name: "Montaj",
    icon: <FiServer />,
    element: AssemblyProducts,
    group: "Ürün Yönetimi",
  },
  {
    path: "/packaging-products",
    name: "Paketleme",
    icon: <FiServer />,
    element: PackagingProducts,
    group: "Ürün Yönetimi",
  },
  {
    path: "/companies",
    name: "Cariler",
    icon: <FiHome />,
    element: Companies,
    group: "Ürün Yönetimi",
  },
  {
    path: "/companies/create",
    name: "Yeni Firma",
    icon: <FiPlus />,
    element: CreateCompany,
    group: "Ürün Yönetimi",
  },
  {
    path: "/companies/:code",
    name: "Firma Detayları",
    icon: <FiHome />,
    element: CompanyDetails,
    group: "Ürün Yönetimi",
  },
  {
    path: "/dealers",
    name: "Bayiler",
    icon: <FiUsers />,
    element: Dealers,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/dealers/create",
    name: "Yeni Bayi",
    icon: <FiPlus />,
    element: CreateDealer,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/devices",
    name: "Cihazlar",
    icon: <FiServer />,
    element: Devices,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/device-models",
    name: translate("UI.MODELS"),
    icon: <FiServer />,
    element: DeviceModels,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/device-models/create",
    name: translate("UI.ADD_DEVICE_MODEL"),
    icon: <FiPlus />,
    element: CreateDeviceModel,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/serial-numbers",
    name: "Seri Numaraları",
    icon: <FiHash />,
    element: SerialNumbers,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/device-sales",
    name: "Siparişler",
    icon: <FiShoppingCart />,
    element: DeviceSales,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/orders",
    name: "Teklifler",
    icon: <FiShoppingCart />,
    element: Orders,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/permission-approves",
    name: "Onaylar",
    icon: <FiCheckSquare />,
    element: PermissionApproves,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/orders/create",
    name: "Yeni Teklif",
    icon: <FiPlus />,
    element: CreateOrder,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/orders/edit/:orderId",
    name: "Teklif Düzenle",
    icon: <FiEdit />,
    element: EditOrder,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/device-sales/create",
    name: "Yeni Cihaz Siparişi",
    icon: <FiPlus />,
    element: CreateDeviceSale,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/device-sales/edit/:saleId",
    name: "Cihaz Siparişi Düzenle",
    icon: <FiEdit />,
    element: EditDeviceSale,
    group: "Stok Yönetimi",
  },
  {
    path: "/users",
    name: "Kullanıcılar",
    icon: <FiUsers />,
    element: Users,
    group: "Müşteri Yönetimi",
  },
  {
    path: "/produced-devices",
    name: "Üretilen Cihazlar",
    icon: <FiServer />,
    element: ProducedDevices,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/activities",
    name: "Aktiviteler",
    icon: <FiEdit />,
    element: Activities,
    group: "Üretim Yönetimi",
  },
  {
    path: "/activities/:type/:id",
    name: "Aktivite Detayları",
    icon: <FiEdit />,
    element: ActivityDetails,
    group: "Üretim Yönetimi",
  },
  {
    path: "/machines",
    name: "Makineler",
    icon: <FiServer />,
    element: Machines,
    group: "Üretim Yönetimi",
  },
  {
    path: "/production-lines",
    name: "Üretim Hatları",
    icon: <FiServer />,
    element: ProductionLines,
    group: "Üretim Yönetimi",
  },
  {
    path: "/production-lines/create",
    name: "Yeni Üretim Hattı",
    icon: <FiPlus />,
    element: ProductionLineFormPage,
    group: "Üretim Yönetimi",
  },
  {
    path: "/production-lines/edit/:id",
    name: "Üretim Hattı Düzenle",
    icon: <FiEdit />,
    element: ProductionLineFormPage,
    group: "Üretim Yönetimi",
  },
  {
    path: "/production-lines/view/:id",
    name: "Üretim Hattı Akışı",
    icon: <FiServer />,
    element: ViewProductionLines,
    group: "Üretim Yönetimi",
  },
  {
    path: "/production-lines/sub",
    name: "Alt Üretim Hatları",
    icon: <FiServer />,
    element: SubProductionLines,
    group: "Üretim Yönetimi",
  },
  {
    path: "/production-lines/sub/view/:id",
    name: "Alt Üretim Hattı Detay",
    icon: <FiServer />,
    element: ViewSubProductionLines,
    group: "Üretim Yönetimi",
  },
  {
    path: "/production-entry",
    name: "Üretim Girişi",
    icon: <FiZap />,
    element: ProductionEntry,
    group: "Üretim Yönetimi",
  },
  {
    path: "/production-logs",
    name: "Üretim Logları",
    icon: <FiFileText />,
    element: ProductionLogs,
    group: "Üretim Yönetimi",
  },
  {
    path: "/inventory",
    name: "Envanter",
    icon: <FiPackage />,
    element: Inventory,
    group: "Üretim Yönetimi",
  },
  {
    path: "/inventory-tree",
    name: "Ürün Ağacı",
    icon: <FiPackage />,
    element: InventoryTree,
    group: "Üretim Yönetimi",
  },
  {
    path: "/inventory/add",
    name: "Envanter Ekle",
    icon: <FiPlus />,
    element: AddInventory,
    group: "Üretim Yönetimi",
  },
  {
    path: "/inventory/additions",
    name: "Envanter Girişleri",
    icon: <FiPackage />,
    element: InventoryAdditions,
    group: "Üretim Yönetimi",
  },
  {
    path: "/inventory/add/:id",
    name: "Envanter Ekle",
    icon: <FiPlus />,
    element: AddInventory,
    group: "Üretim Yönetimi",
  },
  {
    path: "/machine-assignments",
    name: "Makine Atamaları",
    icon: <FiUsers />,
    element: MachineAssignments,
    group: "Üretim Yönetimi",
  },
  {
    path: "/machine-assignments/create",
    name: "Yeni Makine Ataması",
    icon: <FiPlus />,
    element: CreateMachineAssignment,
    group: "Üretim Yönetimi",
  },
  {
    path: "/machine-assignments/edit/:id",
    name: "Makine Ataması Düzenle",
    icon: <FiEdit />,
    element: EditMachineAssignment,
    group: "Üretim Yönetimi",
  },
  {
    path: "/deliveries",
    name: "Teslimatlar",
    icon: <FiShoppingCart />,
    element: Deliveries,
    group: "Stok Yönetimi",
  },
  {
    path: "/deliveries/create",
    name: "Yeni Teslimat",
    icon: <FiPlus />,
    element: CreateDelivery,
    group: "Stok Yönetimi",
  },
  {
    path: "/deliveries/view/:id",
    name: "Teslimat Detayları",
    icon: <FiShoppingCart />,
    element: ViewDelivery,
    group: "Stok Yönetimi",
  },
  {
    path: "/deliveries/edit/:id",
    name: "Teslimat Düzenle",
    icon: <FiEdit />,
    element: CreateDelivery,
    group: "Stok Yönetimi",
  },
  {
    path: "/stock-products",
    name: "Stok Ürünleri",
    icon: <FiPackage />,
    element: StockProducts,
    group: "Stok Yönetimi",
  },
  {
    path: "/defective-products",
    name: "Arızalı Ürünler",
    icon: <FiAlertCircle />,
    element: DefectiveProducts,
    group: "Ürün Yönetimi",
  },
  {
    path: "/device-monitor",
    name: "Cihaz İzleme",
    icon: <FiServer />,
    element: DeviceMonitor,
    group: "Cihaz Yönetimi",
  },
  {
    path: "/logs",
    name: "Uygulama Logları",
    icon: <FiFileText />,
    element: Logs,
    group: "Sistem Yönetimi",
  },
  {
    path: "/privacy-policy",
    name: "Gizlilik Politikası",
    icon: <FiFileText />,
    element: PrivacyPolicy,
    group: "Sistem Yönetimi",
  },
  {
    path: "/user-profiles",
    name: "Kullanıcı Profilleri",
    icon: <FiUsers />,
    element: UserProfiles,
    group: "Sistem Yönetimi",
  },
  {
    path: "/user-profiles/add",
    name: "Kullanıcı Profili Ekle",
    icon: <FiUsers />,
    element: ProfileForm,
    group: "Sistem Yönetimi",
    hideFromMenu: true,
  },
  {
    path: "/user-profiles/edit/:id",
    name: "Kullanıcı Profili Düzenle",
    icon: <FiUsers />,
    element: ProfileForm,
    group: "Sistem Yönetimi",
    hideFromMenu: true,
  },
  {
    path: "/system/companies",
    name: "Sistem Firmaları",
    icon: <FiLayers />,
    element: SystemCompanies,
    group: "Sistem Yönetimi",
  },
  {
    path: "/system/licenses",
    name: "Lisans Yönetimi",
    icon: <FiShield />,
    element: Licenses,
    group: "Sistem Yönetimi",
  },
  {
    path: "/shifts",
    name: "Vardiyalar",
    icon: <FiClock />,
    element: Shifts,
    group: "Üretim Yönetimi",
  },
  {
    path: "/shifts/create",
    name: "Yeni Vardiya",
    icon: <FiPlus />,
    element: ShiftForm,
    group: "Üretim Yönetimi",
  },
  {
    path: "/shifts/edit/:id",
    name: "Vardiya Düzenle",
    icon: <FiClock />,
    element: ShiftForm,
    group: "Üretim Yönetimi",
  },
  {
    path: "/stopping-groups",
    name: "Duruş Grupları",
    icon: <FiList />,
    element: StoppingGroups,
    group: "Üretim Yönetimi",
  },
  {
    path: "/stop-reasons",
    name: "Duruş Nedenleri",
    icon: <FiAlertCircle />,
    element: StopReasons,
    group: "Üretim Yönetimi",
  },
  {
    path: "/oee-classes",
    name: "OEE Sınıfları",
    icon: <FiList />,
    element: OEEClasses,
    group: "Üretim Yönetimi",
  },
  {
    path: "/oee-groups",
    name: "OEE Grupları",
    icon: <FiList />,
    element: OEEGroups,
    group: "Üretim Yönetimi",
  },
  {
    path: "/machine-stop-logs",
    name: "Duruş Kayıtları",
    icon: <FiStopCircle />,
    element: MachineStopLogs,
    group: "Üretim Yönetimi",
  },
  {
    path: "/teep",
    name: "TEEP Analizi",
    icon: <FiBarChart2 />,
    element: TEEP,
    group: "Üretim Yönetimi",
  },
  {
    path: "/machine-monitor",
    name: "Makine Canlı İzleme",
    icon: <FiBarChart2 />,
    element: MachineMonitor,
    group: "Üretim Yönetimi",
  },
  {
    path: "reports/machine-report",
    name: "Makine Raporu",
    icon: <FiTrendingUp />,
    element: MachineReport,
    group: "Üretim Yönetimi",
  },
  {
    path: "/scrap-entry",
    name: "Hurda Girişi",
    icon: <FiCheckSquare />,
    element: ScrapEntry,
    group: "Üretim Yönetimi",
  },
  {
    path: "/scrap-groups",
    name: "Hurda Grupları",
    icon: <FiLayers />,
    element: ScrapGroups,
    group: "Üretim Yönetimi",
  },
  {
    path: "/parts",
    name: "Parçalar",
    icon: <FiList />,
    element: Parts,
    group: "Üretim Yönetimi",
  },
  {
    path: "/part-units",
    name: "Parça Birimleri",
    icon: <FiList />,
    element: PartUnits,
    group: "Üretim Yönetimi",
  },
  {
    path: "/part-variants",
    name: "Parça Varyantları",
    icon: <FiList />,
    element: PartVariants,
    group: "Üretim Yönetimi",
  },
  {
    path: "/parts/:id/stock-additions",
    name: "Stok Girişleri",
    icon: <FiTrendingUp />,
    element: PartStockAdditions,
    group: "Üretim Yönetimi",
  },
  {
    path: "/part-machines",
    name: "Parça / Makine",
    icon: <FiList />,
    element: PartMachines,
    group: "Üretim Yönetimi",
  },
  {
    path: "/part-machines/assign",
    name: "Yeni Makine Ataması",
    icon: <FiPlus />,
    element: PartMachineAssignmentForm,
    group: "Üretim Yönetimi",
  },
  {
    path: "/part-machines/assign/:machineId",
    name: "Makine Ataması Düzenle",
    icon: <FiEdit />,
    element: PartMachineAssignmentForm,
    group: "Üretim Yönetimi",
  },
  {
    path: "/part-machines/view/:machineId",
    name: "Makine Ataması Detay",
    icon: <FiList />,
    element: PartMachineAssignmentView,
    group: "Üretim Yönetimi",
  },
  {
    path: "/part-assemblies",
    name: "Montaj Parçaları",
    icon: <FiList />,
    element: PartAssemblies,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/oee",
    name: "Özet Rapor",
    element: OEEReport,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/oee/by-machine",
    name: "Makine Bazlı Rapor",
    element: OEEByMachineReport,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/production",
    name: "Üretim Raporları",
    element: ProductionReportRedirect,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/production/by-part/per-part",
    name: "Üretim Özeti",
    element: ProductionByPartPerPart,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/production/by-part/trend",
    name: "Üretim Çizgi Grafiği",
    element: ProductionByPartTrend,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/production/by-part/matrix",
    name: "Üretim Matrisi",
    element: ProductionByPartMatrix,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/production/by-machine/trend",
    name: "Üretim Çizgi Grafiği",
    element: ProductionByMachineTrend,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/production/by-machine/distribution",
    name: "Günlük Üretim Tablosu",
    element: ProductionByMachineDistribution,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/production/by-machine/totals",
    name: "Üretim Özeti",
    element: ProductionByMachineTotals,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/quality",
    name: "Kalite Analizi",
    element: QualityReportRedirect,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/quality/trend",
    name: "Özet Raporu",
    element: QualityTrendReport,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/quality/by-part",
    name: "Parça Başına Red",
    element: QualityByPartReport,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/downtime",
    name: "Duruş Analizi",
    element: DowntimeReportRedirect,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/downtime/trend",
    name: "Özet Raporu",
    element: DowntimeTrendReport,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/downtime/reasons",
    name: "Duruş Sebep Raporu",
    element: DowntimeReasonsReport,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/downtime/by-machine",
    name: "Makine Duruş Raporu",
    element: DowntimeByMachineReport,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/device-status",
    name: "Ürün Analizi",
    element: DeviceStatusReport,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/activities",
    name: "Operatör Aktiviteleri",
    element: ActivitiesReport,
    group: "Üretim Yönetimi",
  },
  {
    path: "/reports/sales",
    name: "Sipariş Raporları",
    element: SalesReportRedirect,
    group: "Raporlar",
  },
  {
    path: "/reports/sales/trend",
    name: "Sipariş Trendi",
    element: SalesTrendReport,
    group: "Raporlar",
  },
  {
    path: "/reports/sales/by-model",
    name: "Model Bazlı Sipariş",
    element: SalesByModelReport,
    group: "Raporlar",
  },
  {
    path: "/reports/sales/revenue",
    name: "Gelir Analizi",
    element: SalesRevenueReport,
    group: "Raporlar",
  },
  {
    path: "/reports/deliveries",
    name: "Teslimat Raporları",
    element: DeliveriesReportRedirect,
    group: "Raporlar",
  },
  {
    path: "/reports/deliveries/trend",
    name: "Aylık Teslimat",
    element: DeliveriesTrendReport,
    group: "Raporlar",
  },
  {
    path: "/reports/deliveries/by-model",
    name: "Model Bazlı Teslimat",
    element: DeliveriesByModelReport,
    group: "Raporlar",
  },
  {
    path: "epc",
    name: "EPC",
    element: EPC,
    group: "Üretim Yönetimi",
  },
  {
    path: "/production-planning",
    name: "Üretim Planları",
    element: ProductionPlans,
    group: "Üretim Yönetimi",
  },
  {
    path: "/production-planning/feasibility",
    name: "Üretilebilirlik Analizi",
    element: FeasibilityAnalysis,
    group: "Üretim Yönetimi",
  },
  {
    path: "/production-planning/shortage",
    name: "Eksik Malzeme Raporu",
    element: ShortageReport,
    group: "Üretim Yönetimi",
  },
  {
    path: "/notifications",
    name: "Bildirimler",
    element: Notifications,
    group: "Bildirimler",
  },
  {
    path: "/settings/notifications",
    name: "Bildirim Yönetimi",
    element: NotificationSettings,
    group: "Bildirimler",
  },
  {
    path: "/approval-workflows",
    name: "Onay Akışları",
    icon: <FiShield />,
    element: ApprovalWorkflows,
    group: "Kullanıcı Yönetimi",
  },
  {
    path: "/approval-workflows/new",
    name: "Yeni Onay Akışı",
    icon: <FiShield />,
    element: WorkflowForm,
    group: "Kullanıcı Yönetimi",
    hideFromMenu: true,
  },
  {
    path: "/approval-workflows/edit/:id",
    name: "Onay Akışı Düzenle",
    icon: <FiShield />,
    element: WorkflowForm,
    group: "Kullanıcı Yönetimi",
    hideFromMenu: true,
  },
];

export default routes;
